import { render, staticRenderFns } from "./PlaceTypesOrder.vue?vue&type=template&id=37e54ea8&"
import script from "./PlaceTypesOrder.vue?vue&type=script&lang=js&"
export * from "./PlaceTypesOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports